"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Form = require("../Form");

var _FieldSet = _interopRequireDefault(require("../FieldSet"));

var _RadioField = _interopRequireDefault(require("../RadioField"));

var RadioFieldSet = function RadioFieldSet(_ref) {
  var options = _ref.options,
      label = _ref.label,
      value = _ref.value,
      direction = _ref.direction,
      alias = _ref.alias,
      className = _ref.className,
      moreProps = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["options", "label", "value", "direction", "alias", "className"]);
  return /*#__PURE__*/_react.default.createElement(_FieldSet.default, {
    direction: direction,
    label: label,
    className: (alias + " " + className).trim()
  }, options.map(function (option) {
    return /*#__PURE__*/_react.default.createElement(_RadioField.default, (0, _extends2.default)({
      key: option.value,
      checked: value === option.value
    }, moreProps, option));
  }));
};

RadioFieldSet.propTypes = {
  value: _propTypes.default.string,
  label: _propTypes.default.string,
  alias: _propTypes.default.string,
  className: _propTypes.default.string,
  direction: _propTypes.default.string,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    value: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired
  }))
};
RadioFieldSet.defaultProps = {
  options: [],
  direction: 'column',
  alias: 'RadioFieldSet',
  className: ''
};

var _default = (0, _Form.formalizer)(RadioFieldSet);

exports.default = _default;